import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharingService } from '../../services/sharing.service';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { WebpayService } from '../../services/webpay.service';
import { SystemService } from 'src/app/base/services/system.service';
import { DOCUMENT } from '@angular/common';



@Component({
    selector: 'app-aprobado',
    templateUrl: './aprobado.component.html',
    styleUrls: ['./aprobado.component.css'],
})

export class AprobadoComponent {
    constructor(private activeRoute: ActivatedRoute,
        private sharingObservable: SharingService,
        private messageService: MessageService,
        private webpay: WebpayService,
        private systemService: SystemService,
        @Inject(DOCUMENT) private document: Document) { }

    data: any;

    miFormulario = new FormGroup({
        datos: new FormControl('', [Validators.required]),
        correo: new FormControl('', [Validators.required, Validators.email]),
    })

    ngOnInit() {
        this.systemService.setLoading(true);
        this.sharingObservable.sharingObservable.subscribe((e: any) => {
            this.data = JSON.parse(e);
        });

        this.miFormulario.patchValue({
            datos: this.data.datos.RespuestaWebpay
        });

        this.systemService.setLoading(false);

        if (this.data.hasOwnProperty("extras")
            && this.data.extras != undefined
            && this.data.extras != null
            && this.data.extras.hasOwnProperty("correo")
            && this.data.extras.correo != undefined
            && this.data.extras.correo != null
            && this.data.extras.correo.trim().length > 0) {

            setTimeout(() => {

                this.messageService.add({
                    life: 7000, severity: 'info', summary: 'Comprobante de Pago',
                    detail: 'Se envió comprobante a ' + this.data.extras.correo + ', revise su casilla de correo'
                });
            }, 2000);

        }
    }

    async volver() {
        this.systemService.setLoading(true);
        this.document.location.href = await this.webpay.setBotonVolver(window.location.href.split('?uid=')[1], this.data.urlRetorno);
        this.systemService.setLoading(false);
    }


    async onSubmit() {

        this.messageService.add({ severity: 'info', summary: 'Enviando', detail: 'Enviando correo' });

        this.systemService.setLoading(true);



        let webpayResponse = await this.webpay.enviaCorreo(this.miFormulario.get('correo').value, this.miFormulario.get('datos').value);

        this.systemService.setLoading(false);

        if (webpayResponse === undefined) {

            this.messageService.add({ severity: 'success', summary: 'Enviado', detail: 'Correo enviado, verifique su correo' });


        } else {

            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al enviar correo' });
        }


    }
}
